import { z } from 'zod';
export default {
  valueType: 'string*',
  valueValidator: z.array(z.string()).optional().nullable()
};